import React from "react";
import InvoicesList from "./components/InvoiceList";

const Invoices = (props: any) => {
  return <InvoicesList {...props} />;
};

export default Invoices;
